import { SEARCH_TYPE } from '@/containers/Order/Index/constant'

export const REFUND_SEARCH_OPTIONS = [
  {
    label: 'order.index.search.orderMcId',
    value: SEARCH_TYPE.ORDER_MC_ID,
  },
  {
    label: 'order.index.search.outboundOrderId',
    value: SEARCH_TYPE.ORDER_SHORT_ID,
  },
  {
    label: 'order.index.search.expressId',
    value: SEARCH_TYPE.LOGISTICS_EXPRESS_ID,
  },
  {
    label: 'common.skuCode',
    value: SEARCH_TYPE.OUTBOUND_ORDER_SKUID,
  },
  {
    label: 'common.skuName',
    value: SEARCH_TYPE.SKU_NAME,
  },
  {
    label: 'common.recipient',
    value: SEARCH_TYPE.RECIPIENT,
  },
]

/** 退货地址类型 */
export const CONSIGNEE_TYPE_ENUMS = {
  WAREHOSUE: 'warehouse',
  CUSTOM: 'custom',
} as const

export const CONSIGNEE_TYPE_OPTIONS = [
  {
    value: CONSIGNEE_TYPE_ENUMS.WAREHOSUE,
    label: 'common.warehouse',
  },
  {
    value: CONSIGNEE_TYPE_ENUMS.CUSTOM,
    label: 'refund.custom.address',
  },
]

/** 退回类型 */
export const REFUND_TYPE_ENUMS = {
  /** 客退 */
  customer: 'customer',
  /** 运退 */
  transport: 'transport',
} as const

export const REFUND_SOURCE_OPTIONS = [
  {
    value: 'MANUAL',
    label: 'order.source.handCreate',
  },
  {
    value: 'SYSTEM',
    label: 'enums.inboundSources.system',
  },
  {
    value: 'ECCANG',
    label: 'order.source.ECCANG',
  },
]
